import * as React from 'react';
import propTypes from 'prop-types';
import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';
import Lazy from '../../../../components/lazy';
import * as S from './styles';

const ArticlePuff = ({ imageUrl, pathName, preamble, title, linkText }) => (
  <Panel header={<PanelHeader />}>
    <S.ArticlePuff>
      <S.ImageWrapper>
        <Lazy loadOnIdle>
          <S.ImageInner imageUrl={imageUrl} />
        </Lazy>
      </S.ImageWrapper>
      <S.TextContainer>
        <h3>{title}</h3>
        <p>{preamble}</p>
        {linkText ? (
          <S.ArticleLink href={pathName}>{linkText}</S.ArticleLink>
        ) : (
          []
        )}
      </S.TextContainer>
    </S.ArticlePuff>
  </Panel>
);

ArticlePuff.propTypes = {
  imageUrl: propTypes.string.isRequired,
  pathName: propTypes.string.isRequired,
  preamble: propTypes.string.isRequired,
  linkText: propTypes.string,
  title: propTypes.string.isRequired,
};

ArticlePuff.defaultProps = {
  linkText: undefined,
};

export default ArticlePuff;
